import React from 'react';
import { observer } from 'mobx-react';
import { Box, useTheme } from '@mui/material';
import LoadMoreButton from '../LoadMoreButton';
import { InboxesListsViewName } from './const';
import { useData } from './hooks';
import CustomListInboxes from '10.quickConnect.app/components/domain/Home/Shared/CustomListInboxes';
import { ListColumnOrRowContainer } from '10.quickConnect.app/components/domain/Home/styles';
import InboxLine from '10.quickConnect.app/components/domain/Home/Inboxes/InboxLine';

const InboxesLists = () => {
  const theme = useTheme();
  const {
    preFilled,
    myOwnTransfers,
    tasks,
    others,
    sortFn,
    prefilledItemsTitle,
    myOwnTransfersTitle,
    tasksItemsTitle,
    othersItemsTitle,
    itemsShown,
    totalItemsCount,
    hasMoreItems,
    loadMoreItems,
  } = useData();

  return (
    <Box
      data-cy={InboxesListsViewName}
      sx={{
        ...ListColumnOrRowContainer(theme),
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' },
          overflowY: 'auto',
        }}
      >
        {preFilled && preFilled.length > 0 && (
          <CustomListInboxes title={prefilledItemsTitle} items={preFilled} RenderLine={InboxLine} sortFn={sortFn} />
        )}
        {myOwnTransfers && myOwnTransfers.length > 0 && (
          <CustomListInboxes
            title={myOwnTransfersTitle}
            items={myOwnTransfers}
            RenderLine={InboxLine}
            sortFn={sortFn}
          />
        )}
        {tasks && tasks.length > 0 && (
          <CustomListInboxes title={tasksItemsTitle} items={tasks} RenderLine={InboxLine} sortFn={sortFn} />
        )}
        {others && others.length > 0 && (
          <CustomListInboxes title={othersItemsTitle} items={others} RenderLine={InboxLine} sortFn={sortFn} />
        )}
      </Box>
      <LoadMoreButton
        itemsShown={itemsShown}
        totalItemsCount={totalItemsCount}
        hasMoreItems={hasMoreItems}
        onLoadMore={loadMoreItems}
      />
    </Box>
  );
};
export default observer(InboxesLists);
